module.exports = {
	
	language: {
	    name: '印尼'
	},
		
	login: {
		title:'ahshek',
		home: 'Halaman utama',
		producet: 'Produk',
		producets: 'Beli sekarang',
		serives: 'LAYANAN',
		serives2: 'Layanan',

		news: 'Berita',
		about: 'Tentang Fotile',
		follow: 'SOSIAL MEDIA',
		rangehoods: 'Penghisap asap',
		hobs: 'Kompor',
		lectricovens: 'Oven listrik',
		steamovens: 'Steam oven',
		micovens: 'Microwave oven',
		dishwasher: 'Sink dishwasher',
		dishwasher2: 'Sink dishwasher',
		allproduct:"semua produk ",
		faq: 'FAQ',
		manualdownload: 'Pendaftaran Garansi',
		exhibitionhallquery: 'saran dan kritik',
		complaintjoin: 'Unduh Buku Manual',
		complaintjoin1: 'Unduh Brosur',
		engineeing: 'Kerjasama teknik',
		aboutfotial: 'Perusahaan kami',
		happykitchen: 'Happy Kitchen',
		globalout: 'pembagian global',
		fotilenews : 'Berita Fotile',
		fotilemedia: 'Media Fotile',
		creativemenu : 'Menu',
		contentus : 'hubungi kami',
		contentusnow : 'Hubungi Kami',
		cookinglife: 'Teknologi tercanggih membantu Anda menjalani gaya hidup memasak yang revolusioner melalui pengalaman memasak yang menyenangkan.',
		allright : 'seluruh hak cipta PT FOTILE ELECTRICAL APPLIANCE INDONESIA, Ltd dilindungi undang undang',
		sitemap : 'peta situs web',
		legalnotice : 'pemberitahuan hukum',
		globalsite: 'situs web global',
		biginning : 'Fotile selalu fokus pada bidang peralatan dapur',
		nowhave:'FOTILE memiliki 8 jenis produk, yang terdiri dari : penghisap asap, kompor tanam,microwave tanam, oven tanam, steam oven tanam,  sink dishwasher,pembersih udara &Water purifier',
		happytochoose: 'Kebahagiaan dimulai dari dapur Anda',
		allowaystodo : 'FOTILE selalu berkomitmen untuk menyediakan produk dan layanan berkualitas tinggi, menciptakan gaya hidup sehat dan ramah lingkungan, dan mendukung lebih banyak keluarga untuk menikmati kehidupan yang bahagia. Selama 25 tahun terakhir, FOTILE telah membantu keluarga di seluruh dunia meningkatkan kualitas dapur dan melindungi kesehatan mereka. FOTILE terus berkembang untuk mendukung kebahagiaan ratusan juta keluarga.',
		moreandmore: 'lainnya',
		number1:"Fotile menginvestasikan tidak kurang dari 5% dari penjualan untuk penelitian dan pengembangan produk setiap tahunnya, serta memiliki tim penelitian dan pengembangan lebih dari 900 orang termasuk ahli di bidang peralatan dapur.",
		number2: "Fotile saat ini sudah memiliki 16000 karyawan di seluruh dunia, selain kekuatan team desain lokal yang kuat, Fotile juga memiliki fasilitas desain di Korea, Jepang, dan tempat lainnya serta memproduksi peralatan dapur kelas atas dengan teknologi manufaktur industri internasional yang canggih",
		number3:"Dinilai di kelas pertama perusahaan pameran kekayaan intelektual nasional oleh Kantor Kekayaan Intelektual Negara pada tahun 2013, FOTILE telah memiliki banyak teknologi inti untuk peralatan dapur. Ini memiliki lebih dari 4.500* paten resmi, termasuk lebih dari 700* paten penemuan, menjadikannya pemimpin dalam industri ini.",
		number4:"Fotile memiliki pusat teknologi yang diakui secara nasional dan laboratorium dengan luas lebih dari 12000 meter persegi yang diakui oleh Layanan Akreditasi Nasional China. Fotile juga telah mendirikan laboratorium penelitian di Jerman, Jepang dan China.",
		newactive: 'Aktivitas informasi',
		newmodel: 'Fotile Enterprise menerapkan model manajemen konfusianisme modern, dan secara aktif berpartisipasi dalam mempromosikan budaya tradisinonal, amal, ramah lingkungan dan usaha kesejahteraan publik lainnya, berusaha untuk mempraktekan tanggung jawab sebagai kewarganegaraan sosial perusahaan.',
		newnext: 'mengetahui Fotile lebih lanjut',
		newsersh: 'Layanan Pelanggan',
		newkonw: 'ingin mengetahui informasi lebih lanjut ? Kami akan mengatur layanan pelanggan untuk menghubungi Anda segera mungkin',
		xielipro: 'seri produk',
		xingnum: 'kode produk',
		conttype: 'kontak informasi',
		submitsing: 'mengirimkan',
		ochoosepro: 'pilih produk',
		ochoosexinghoa: 'pilih kode',
		contrast: 'perbandingan',
		dingyue: 'berlangganan',
		baoxiu: 'kartu garansi',
		protobi: 'perbandingan produk',
		obempty: 'mengosongkan',
		osure: 'yakin',
		mabymost: 'perbandingan paling banyak 3 jenis',
		guige: 'spesifikasi',
		qubie: 'perbedaan',
		shipinvideo: 'video',
		dayijin: 'printer',
		masgomai: 'beli langsung',
		tobuy: 'beli langsung',
		features: 'Fitur',
		prodetail: 'Detail produk',
		teparnters: 'Spesifikasi',
		installation: 'Diagram instalasi',
		manual: 'Katalog produk',
		tuijianpro: 'Produk yang direkomendasikan ',
		mandetai1: 'katalog',
		mandetai2: 'parameter teknis',
		mandetai3: 'petunjuk pemasangan',
		mandetai4: 'kebijakan garansi',
		mandetai5: 'registrasi produk',
		mandetai6: 'brosur',
		cannotdoit: 'sementara tidak tersedia',
		downloadli: 'unduh',
		serisepro: 'Fotile memberikan jawaban untuk anda mengenai pertanyaan umum selama pemakaian berbagai rangkaian produk.',
		pleachoose: 'silakan pilih',
		ochaxue: 'mencari',
		allwholeworld: 'distribusi global',
		wholedetail: 'Fotile maju selangkah demi selangkah dalam menjadi ahli peralatan dapur top di dunia, telah memasuki lebih dari 30 negara yang tersebar di Amerika Utara, Eropa, Australia, Asia dan Afrika',
		tojoinwant: 'Saya ingin bergabung dengan Fotile',
		tothankyou: 'Terimakasih telah menghubungi kami, untuk kepuasan Anda, kami akan bekerja 100% !',
		inputname1: 'nama perusahaan',
		inputname2: 'tahun berdiri',
		inputname3: 'alamat perusahaan',
		inputname4: 'name',
		inputname5: 'nomor handphone',
		inputname6: 'email',
		inputname7: 'message',
		inputname8: 'produk utama',
		casesone: 'Tentang layanan Project FOTILE',
		casesoneson:'Sejak tahun 2005, FOTILE telah membentuk tim pemasaran teknik profesional untuk memasuki bidang jasa real estate. Selain bekerja sama dengan banyak perusahaan real estate dan terus-menerus mengeksplorasi kebutuhan pelanggan dengan tujuan meningkatkan kualitas FOTILE menjadi merek peralatan dapur yang memiliki banyak pelanggan ekslusif dan FOTILE telah mengakuisisi banyak merek peralatan dapur untuk proyek brand peralatan dapur. Hingga saat ini, FOTILE telah bekerja sama dengan ribuan perusahaan real estate di lebih dari 200 kota besar, menengah, dan kecil di seluruh dunia, dan telah berhasil menyelesaikan hampir 10.000 project, serta menjalin kerjasama strategis dengan lebih dari 160 perusahaan real estate terkenal di seluruh dunia dengan hasil yang mengesankan sebagai permulaan',
		casestwo: 'kasus proyek klasik',
		casestwoson: 'Hingga saat ini, di hampir 200 kota besar, kota menengah, dan kota kecil di seluruh negeri, Fotile telah bekerja sama dengan ribuan perusahaan real estate, telah berhasil mengirimkan hampir 10.000 proyek dekorasi yang bagus, dan telah membentuk aliansi strategis dengan lebih dari 160 real estate terkenal. Prestasi yang mengesankan ini masih terus dimuat ulang.',
		casesthere: 'Kerjasama project peralatan dapur',
		casesthereson: 'Jika anda tertarik untuk bekerja sama, silakan isi informasi di bawah ini,dan kami akan menghubungi Anda.',
		oinputname1: 'Nama lengkap：',
		oinputname2: 'Informasi perusahaan：',
		oinputname3: 'Bahasa：',
		oinputname4: 'Nomor telepon：',
		oinputname5: 'Alamat e email：',
		Engineering: 'Tentang Fotile',
		calssing: 'Contoh Project',
		parkservise: 'Jasa Layanan',
		shouafter: 'Proses Layanan',
		gorgeous: 'KAMI MEMILIKI TIM PROJECT YANG BERPENGALAMAN',
		authority: 'Dari survey, pemasangan produk hingga pengiriman ke konsumen, FOTILE memiliki tim professional yanag berpengalaman di bidangnya masing-masing.',
		lens: 'Didukung layanan tim profesional',
		erosion: 'Manajemen proyek berkelanjutan',

		fatal: 'MANAJEMEN PROYEK YANG EFISIEN',
		motive: 'Dari survei area konstruksi, koordinasi pengiriman, dan kontrol kualitas konstruksi hingga penerimaan di lokasi, kami memiliki sistem manajemen proyek yang memenuhi kebutuhan pelanggan selama proses berlangsung.',
		cicumstance: 'Project Responsibility System',
		embody: 'Sistem manajemen proyek yang efisien',

		mutiply: 'INTEGRASI YANG SALING TERHUBUNG',
		wresetle: 'Tim kami memiliki jaringan yang dapat memastikan kualitas produk dan pengiriman barang tepat waktu.',
		pasture: 'Jaminan barang terkirim',
		approval: 'Barang terkirim tepat waktu',

		handing: 'STANDAR MANAJEMEN PROFESIONAL',
		morning: 'Dengan sistem kontrol kualitas terdepan di industri, standar material, dan standar manajemen  serta pelaksanaan yang efisien dari tim layanan kami sendiri, kami memiliki kemampuan untuk memberikan layanan yang terbaik.',
		handsed: 'Standar lingkungan',
		hairsing: 'Standar konstruksi',
		ducking: 'Standar bahan',
		bite: 'Standar proses',

		rabbit: 'Mekanisme masukan di tempat yang cepat dan efisien',
		cakeing: 'Manajer proyek bertanggung jawab atas proyek, dan seluruh proses manajemen proyek dikoordinasikan untuk memastikan masukan di tempat yang cepat dan efisien',
		badanmad: 'sistem manajer proyek',
		smalling: 'tanggung jawab penuh untuk seluruh proses',

		trutle: 'PROSES LAYANAN BEBAS KHAWATIR',
		weeksing: 'Layanan profesional team FOTIE dengan team yang berpengalaman',
		jscket: 'Dukungan layanan',
		shirting: 'Instalasi dengan team profesional',
		sweater: 'Jaminan kepuasan',
		
		hurtsing: 'Jaminan produk berkualitas',
		// potato: '业主入住后的任何咨询、维修申请、投诉和建议均可通过呼叫中心处理，开发商无需担心。',
		tomato: 'Masa garansi 3 tahun sejak tanggal pemasangan (instalas) oleh teknisi Fotile dan 10 tahun untuk motor Range Hood',
		
		Presales: 'Presales',
		Aftersale: 'Layanan Purna Jual',
		Onsale: 'Sales',
		Presales1: 'Survei lokasi',
		Presales2: 'Pemeriksaan lingkungan',
		Presales3: 'Rencana pekerjaan',
		Presales4: 'Saluran pembuangan asap',
		Presales11: 'Teknisi melakukan survei sebelum dan sesudah proyek berlangsung untuk memastikan produk terinstall',
		Presales12: 'Menyesuaikan hasil survei dengan kebutuhan pelanggan,kami menyediakan solusi hemat biaya dan memberikan layanan survei gratis serta dukugan layanan',
		Presales13: 'Sesuai dengan kebutuhan pelanggan dan kondisi peoyek,kami menyediakan pelanggan dengan berbagai solusi,dan dukungan tekins yang teknis yang tepat waktu dan profesional',
		Presales14: 'Kami menyediakan layanan pembutan saluran pembuangan asap untuk memastikan kenyamanan konsumen,tanpa dikenakan biaya',
		
		Onsale1: 'Rencana pengerjaan',
		Onsale2: 'Kolaborasi',
		Onsale3: 'Pasokan langsung dari pabrik',
		Onsale4: 'Koordinasi pengiriman',
		Onsale5: 'Dukungan pemasaran',

		Onsale11: 'Kami membuat rencana kerja sebelum proses pengerjaan untuk menghindari masalah yang mungkin dihadapi dalam proses konstruksi untuk meningkatkan efisiensi kerja.',
		Onsale12: 'Tim teknis kami mengkoordinasikan proses kerja dan bekerja sama dengan tim untuk memastikan kualitas pekerjaan.',
		Onsale13: 'Mekanisme pasokan barang dari pabrik langsung ke lokasi pekerjaan memastikan kualitas produk dan secara efektif meminimalisir kerusakan barang yang disebabkan oleh logistic serta memastikan pengiriman tepat waktu',
		Onsale14: 'Kami berkoordinasi dengan pemilik selama keseluruhan proses, memberikan instruksi produk yang diperlukan dan dukungan layanan untuk meningkatkan kepuasan pelanggan.',
		Onsale15: 'Bekerjasama dengan tim penjualan untuk memberikan layanan berkualitas tinggi, penjelasan prroduk, serta dukungan layanan lainnya.',
		
		Aftersale1: 'Layanan Profesional',
		Aftersale2: 'Garansi',
		Aftersale11: 'Layanan professional dengan perhatian yang tulus serta kejujuran adalah nilai inti kami. Kami berkomitmen untuk menyediakan pelanggan dengan pengalaman layanan yang tepat waktu, profesional, dan penuh perhatian',
		Aftersale12: 'Garansi produk adalah 3 tahun untuk suku cadang (spare part) utama dan 10 tahun untuk semua motor penghisap asap. Periode garansi dihitung sejak tanggal instalasi produk oleh teknisi resmi FOTILE',
		
		allting: 'lainnya',
		informationing: 'Informasi & event',
		squareimage: 'Gambar Fotile',
		gourmet: 'Menu kreatif',
		fantings: 'Selama 20 tahun terkahir, kita membantu keluarga di seluruh dunia meningkatkan lingkungan dapur dan melindungi kesehatan dapur. Demi kebahagiaan ratuasan juta keluarga, kami akan terus maju.',
		cokintmast: 'Fotile berkomitmen untuk menyediakan ruang memasak yang aman dan nyaman kepada Anda, untuk melindungi kesehatan Anda dan keluarga Anda',
		mostdetail:'rincian',
		about1:'Pilihan untuk Dapur Global',
		about11:'FOTILE selalu berkomitmen untuk menyediakan produk dan layanan berkualitas tinggi, menciptakan gaya hidup sehat dan ramah lingkungan, sehingga memungkinkan lebih banyak keluarga menikmati kehidupan dapur yang bahagia. Selama 25 tahun terakhir, kami telah membantu keluarga di seluruh dunia dalam meningkatkan kualitas dapur mereka dan melindungi kesehatan mereka. FOTILE terus berkembang dalam mendukung kebahagiaan ratusan juta keluarga.',
		about2:'R&D dan inovasi Fotile',
		about22:'Sebagai pemimpin di bidang peralatan dapur, FOTILE memiliki keahlian R&D dan desain terbaik dari seluruh dunia, peralatan produksi dapur kelas atas, teknologi manufaktur industri internasional yang canggih, dan pusat R&D di Jerman, Jepang, dan Cina. Pada Maret 2021, FOTILE memiliki lebih dari 4.500 paten resmi, termasuk lebih dari 700 paten penemuan, menjadikannya pemimpin industri. Keunggulan penelitian ilmiah kami memastikan kekuatan inovatif FOTILE. Sejak 2007, FOTILE telah memenangkan 28 iF Awards dan 22 Reddot Awards, serta penghargaan internasional lainnya, dan menjadi pemimpin industri.',
		about3:'DAPUR YANG SEHAT',
		about33:'FOTILE peduli dengan kesehatan setiap pengguna. Kami sangat percaya bahwa dapur bukan hanya tempat untuk membuat makanan tiga kali sehari, tetapi juga ruang di mana sebuah keluarga mengeksplorasi kegembiraan memasak dan berbagi kehidupan bahagia yang penuh cinta. Setiap makanan bukan hanya kebutuhan sehari-hari, tetapi juga ekspresi dari setiap koki keluarga besar terhadap kehidupan. FOTILE berkomitmen untuk menyediakan ruang memasak yang nyaman dan aman bagi Anda serta menjaga kesehatan Anda dan keluarga.',
		about4:'Merek terkemuka di industri',
		about44:'Fotile fokus pada R&D dan produksi peralatan dapur kelas atas, dan memiliki rangkaian lengkap peralatan dapur, termasuk penghisap asap, kompor, steam oven, oven, sink diswasher dan lainnya. Merupakan peralatan dapur pilihan pertama oleh 17juta lebih keluarga di 30 negara di seluruh dunia. Pada tahun 2020, Fotile telah menempati peringkat di dalam 500 merek Asia teratas selama tujuh tahun berturut turut dengan model inovatifnya yang unik dan nilai brand yang mendalam.',
		
		registering:'informasi pelanggan',
		nottoregis:'Fotile tidak akan mengungkapkan informasi pribadi Anda kepada pihak manapun',
		kehunews1:'nama belakang',
		kehunews2:'nama depan',
		kehunews3:'nomor telepon',
		kehunews4:'alamat email',
		kehunews5:'alamat',
		kehunews6:'apartemen/rumah/lainnya',
		kehunews7:'kota',
		kehunews8:'status',
		kehunews9:'kode pos',
		kehunews10:'pilih jenis produk',
		kehunews11:'pilih kode produk',
		kehunews12:'nomor seri produk',
		kehunews13:'dimana kamu membeli produk Fotile ?',
		kehunews14:'pilih langsung atau pencarian pilihan',
		kehunews15:'tanggal beli produk',
		kehunews16: 'Reseller/ Invoice Amazon/ Nomor Pesanan',
		nowtoregister:'daftar sekarang',
		personal:'informasi personal',
		toubuy:'beli produk',
		halsthy:'Kehidupan dapur yang sehat',
		alwaysanli:'Fotile selalu berkomitmen untuk menyediakan produk dan layanan berkualitas tinggi kepada orang - orang, menciptakan gaya hidup yang sehat dan ramah lingkungan, dan memungkinkan lebih banyak keluarga menikmati kehidupan dapur yang aman dan bahagia.',
		joninene:'BERLANGGANAN FOTILE NEWSLETTER',
		ionudd:'Bergabunglah dengan milis kami untuk menerima pengingat produk baru, penawaran khusus',
		
		joininn:'bergabung',
		seriesing:'Pengenalan Seri',
		
		newadd1:'PRODUK UNGGULAN',
		newadd2:'Rekomendasi produk terlaris',
		
    feedback1: 'name',
		feedback2: 'bangsa',
		feedback3: 'Kota',
		feedback4: 'telepon',
		feedback5: 'masalah',
		wantfaku:'Saya ingin umpan balik dan saran',
		wantfakuson: 'Terima kasih banyak atas bantuan dan dukungan Anda!',
		tofaku:'comment',
		

shiname:'FOTILE adalah perusahaan yang berpegang pada visi, misi, dan nilai.',
		hospion:'Ketua dan Presiden:',


borderred:'Silahkan isi kolom ini',
sucssfil:'Dikirim dengan sukses',


serquery:'Permintaan Layanan',
		makesulo: 'Kerjasama Interior',
		











Storename:'Nama toko',

Nomorfaktur:'Nomor faktur',


row1:'Untuk mendaftar produk Anda, silakan memberikan informasi berikut.',
row2:'ditandai dengan',
row3:'wajib diisi.',
row4:'Product information',
row5:'Silakan klik [tambah produk ini] untuk menambah produk jaminan',
row6:'Sumber apa yang Anda tahu tentang Fotile (pilih lebin dari 1)',
row7:'Alasan untuk memilih produk Fotile (pilih lebin dari 1)',
row8:'Detail toko',
row9: 'Informasi pribadi',

cherdkk1:'Mengiklan promosi bahasa',
cherdkk2:'Rekomendasi teman',
cherdkk3:'Fotile Facebook / website',
cherdkk4:'pameran',
cherdkk5:'Rekomendasi penjual',
cherdkk6:'Design',
cherdkk7:'Kualitas',
cherdkk8:'Fungsi',
cherdkk9:'Harga',



row10:'Garansi tidak termasuk ',
row11:'1. Kerusakan akibat pemakaian normal (seperti bola lampu, filter, selang fleksibel, karet, dll.)',
row12:'2. Kerusakan pada bagian luar (perubahan warna setelah penggunaan yang lama), aksesoris, barang eksternal, yang dapat dilepas dan/atau pecah (yaitu pintu kaca, piringan penghisap, baterai, cangkir minyak, filter , permukaan stainless steel)',
row13:'3. Kerusakan yang diakibatkan oleh tindakan pengabaian atau penyalahgunaan atau kelalaian atau layanan yang tidak sah, pengangkutan, pemasangan yang tidak benar, pembongkaran, pengubahan dan modifikasi oleh pihak yang tidak berwenang.',
row14:'4. Kerusakan yang disebabkan langsung atau tidak langsung oleh kejadian force majeure yang terjadi di luar kendali Fotile Indonesia',
row15:'5. Tegangan tidak normal atau penggunaan genset dan/atau digunakan tidak sesuai dengan buku petunjuk.',
row16:'In Bahasa Indonesia',
row17:'1. Garansi ini hanya berlaku jika pendaftaran selesai dan berhasil dikirim kembali ke Fotile Indonesia.',
row18:'2. Garansi ini hanya berlaku untuk produk yang dibeli dari dealer resmi Fotile Indonesia',
row19:'3. Garansi tidak dapat dipindahtangankan.',
row20:'4. Pelanggan harus mengikuti semua persyaratan pengoperasian dan pemeliharaan rutin yang disediakan dalam manual pengguna.',
row21:'5. Garansi terhadap suku cadang yang rusak dan kesalahan pabrik. Fotile atas kebijakannya sendiri akan memperbaiki produk atau menggantinya dengan produk yang setara. Fotile dapat menggunakan suku cadang baru dan/atau rekondisi yang dibuat oleh berbagai produsen dalam melakukan garansi. Dalam hal perbaikan atau penggantian, Fotile akan memiliki semua suku cadang yang dilepas dari produk.',
row22:'6. Produk Fotile tidak boleh diperbaiki atau diservis oleh pihak manapun selain dari teknisi yang ditunjuk Fotile. Teknisi kami berhak dan berwenang untuk mengenakan biaya layanan/ menolak perbaikan produk jika kartu garansi tidak dapat ditunjukkan oleh pelanggan saat layanan diperlukan.',
row23:'7. Masa garansi, tiga (3) tahun servis dan suku cadang  (10 tahun untuk Motor Hood), kompor, oven & wastafel pencuci piring sejak tanggal pembelian atau tanggal pemasangan (Pemasangan oleh Teknisi Fotile)',



agree1:'*Saya telah membaca dan menerima syarat dan ketentuan di atas serta pengecualian garansi',
agree2:'Dengan ini saya setuju, mengakui dan menyetujui pengumpulan, penggunaan, dan pemrosesan data pribadi saya (sebagaimana didefinisikan dalam Undang-Undang Perlindungan Data Pribadi) oleh Fontai Indonesia dan mitra bisnisnya untuk tujuan garansi, penjualan, layanan, dan pemasaran, sehingga Fontai Indonesia dapat memungkinkan saya Tetap mendapat informasi tentang pembaruan/informasi apa pun dan merujuk ke acara, produk, layanan, dan informasi pemasaran Fantawild Indonesia.',

restnow:'Daftar sekarang',





callbig:'panggilan',

call1:'Dr',
call2:'Mdm',
call3:'Mr',
call4:'Mrs',
call5:'Ms',
call6:'Prof',


call7:'Nama Pelanggan',
call8:'Email Address',
call9:'Provinsi',
call10:'Kota',
call11:'Kecamatan',
call12:'Kode Pos',
call13:' Mobile Number/Home Phone Number',
call14:'Alamat',




timeone1: 'Working hours (08.30 - 17.30) Monday - Friday',
		timeone2: '24 hours service in 7 days a week (Response within 1 x 12 hours)',




querythere1:'FOTILE',
querythere2:'Daftar produk',
querythere3:'Perbandingan',
querythere4:'Rincian produk',
querythere6:'Pendaftaran Garansi',
querythere7:'Permintaan Layanan',
querythere8:'Unduh Buku Manual',
querythere9:'Unduh Brosur',
querythere10:'Lokasi Toko',
querythere11:'Berita Fotile',
querythere12:'Media Fotile',
querythere13:'Menu',
querythere14:'Lokasi Toko Detail',
querythere15:'Berita Fotile Detail',
querythere16:'Media Fotile Detail',
querythere17:'Menu Detail',
querythere18:'Perusahaan kami',
querythere19:'Happy Kitchen',
querythere20:'Kartu garansi',


num7o:'Pembersih air',
num8o:'pembersih udara',


quernewone:'Pengiriman informasi',






	}
}
